import { client as elevioClient } from 'elevio';
import { AnalyticsMenu, AnalyticsMenuAction } from 'lib-analytics-ui';
import { ampli } from 'lib-shared-tracking';
import { Fragment, memo, useMemo } from 'react';

import { AppLink } from 'components/appLink';
import { articles } from 'utils/elevio';

import { useDashboardLastRefresh } from '../../../../utils/useDashboardLastRefresh';

export const FavoriteDashboardControls = memo(
  function FavoriteDashboardControls(): JSX.Element {
    const { refreshAction } = useDashboardLastRefresh({
      dashboardType: 'favorite',
    });

    const actions = useMemo(
      (): AnalyticsMenuAction[] => [
        refreshAction,
        {
          type: 'divider',
        },
        {
          type: 'link',
          label: 'TV mode',
          icon: 'presentation',
          link: <AppLink path="/tv/dashboard/organization" />,
          onClick: () => {
            ampli.dashboardGlobalTvDashboardClicked();
          },
        },
        {
          type: 'divider',
        },
        {
          type: 'button',
          label: 'Help and documentation',
          icon: 'question',
          onClick: () => {
            elevioClient.openArticle(
              articles.dashboard.favorites.documentation,
            );
          },
        },
      ],
      [refreshAction],
    );

    return (
      <Fragment>
        <AnalyticsMenu actions={actions} />
      </Fragment>
    );
  },
);
